export default "__VITE_ASSET__f512ab35__"